import React, { useState } from "react"
import "./partners.sass"
import IconHouse from "../../images/store@2x.png"
import IconCar from "../../images/drive-eta@2x.png"
import { Link } from "gatsby-plugin-intl"
import { defaultIntl } from "../../utils"

export default ({ intl = defaultIntl }) => {
  return (
    <div className="partners">
      <div className="container">
        <article className="media">
          <div className="media-left">
            <figure className="image is-64x64">
              <img src={IconHouse} alt="Image" />
            </figure>
          </div>
          <div className="media-content">
            <Link to="/partner">
              <h3>{intl.formatMessage({ id: "index.partner.a.title" })}</h3>
              <p>
                {intl.formatMessage({ id: "index.partner.a.desc" })}
                <span className="arrow">&nbsp;</span>
              </p>
            </Link>
          </div>
        </article>
        <article className="media">
          <div className="media-left">
            <figure className="image is-64x64">
              <img src={IconCar} alt="Image" />
            </figure>
          </div>
          <div className="media-content">
            <Link to="/driver">
              <h3>{intl.formatMessage({ id: "index.partner.b.title" })}</h3>
              <p>
                {intl.formatMessage({ id: "index.partner.b.desc" })}
                <span className="arrow">&nbsp;</span>
              </p>
            </Link>
          </div>
        </article>
      </div>
    </div>
  )
}
